import api from './api';

const adminService = {
  getDashboardStats: () => api.get('/admin/dashboard'),
  getSystemHealth: () => api.get('/admin/system-health'),

  // User management
  getUsers: (params: Record<string, string | number | undefined>) =>
    api.get('/admin/users', { params }),
  getUser: (id: string) => api.get(`/admin/users/${id}`),
  createUser: (data: { email: string; firstName: string; lastName: string; role: string; password?: string }) =>
    api.post('/admin/users', data),
  updateUser: (id: string, data: { firstName?: string; lastName?: string; email?: string; role?: string }) =>
    api.put(`/admin/users/${id}`, data),
  updateUserStatus: (id: string, data: { isActive: boolean }) =>
    api.patch(`/admin/users/${id}/status`, data),
  resetUserPassword: (id: string, data?: { password?: string }) =>
    api.patch(`/admin/users/${id}/reset-password`, data || {}),
  deleteUser: (id: string) => api.delete(`/admin/users/${id}`),
  bulkImportUsers: (data: { users: Array<{ email: string; firstName: string; lastName: string; role: string }> }) =>
    api.post('/admin/users/bulk-import', data),

  // Workshop management
  getWorkshops: (params: Record<string, string | number | undefined>) =>
    api.get('/admin/workshops', { params }),
  getWorkshop: (id: string) => api.get(`/admin/workshops/${id}`),
  getInstructors: () => api.get('/admin/workshops/instructors'),
  transferWorkshop: (id: string, newInstructorId: string) =>
    api.patch(`/admin/workshops/${id}/transfer`, { newInstructorId }),
  updateWorkshopStatus: (id: string, status: string) =>
    api.patch(`/admin/workshops/${id}/status`, { status }),
  deleteWorkshop: (id: string) =>
    api.delete(`/admin/workshops/${id}`, { data: { confirm: true } }),

  // Session management
  getSessions: (params: Record<string, string | number | undefined>) =>
    api.get('/admin/sessions', { params }),
  getSession: (id: string) => api.get(`/admin/sessions/${id}`),
  getActiveSessions: () => api.get('/admin/sessions/active'),
  getSessionWorkshops: () => api.get('/admin/sessions/workshops'),
  forceEndSession: (id: string, reason: string) =>
    api.patch(`/admin/sessions/${id}/force-end`, { reason }),

  // Settings
  getSettings: () => api.get('/admin/settings'),
  getSettingsByCategory: (category: string) => api.get(`/admin/settings/${category}`),
  updateSettings: (settings: Array<{ key: string; value: string | boolean | number }>) =>
    api.put('/admin/settings', { settings }),

  // Audit
  getAuditLog: (params: Record<string, string | number | undefined>) =>
    api.get('/admin/audit', { params }),
  exportAuditLog: (params: Record<string, string | undefined>) =>
    api.get('/admin/audit/export', { params, responseType: 'blob' as const }),

  // Registration Metrics
  getRegistrationMetrics: () => api.get('/admin/registration-metrics'),

  // Blocked Domains
  getBlockedDomains: () => api.get('/admin/blocked-domains'),
  updateBlockedDomains: (domains: string[]) => api.put('/admin/blocked-domains', { domains }),
  validateEmailDomain: (email: string) => api.post('/admin/blocked-domains/validate', { email }),

  // Desktops
  getDesktops: () => api.get('/admin/desktops'),
  getDesktopConnections: () => api.get('/admin/desktops/connections'),
  killDesktopConnection: (connectionId: string) =>
    api.delete(`/admin/desktops/connections/${connectionId}`),
  getDesktopHealth: () => api.get('/admin/desktops/health'),
};

export default adminService;
